module.exports = __webpack_public_path__ + "static/media/template5-carousel.eefed8ed.webp";